<template>
    <div
        class="outlet-banner"
        :style="{
            backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0, 0.40)), url('/images/terms and condition/CONDITIONS.jpg')`,
        }"
    >
    </div>
    <div class="privacy-container">
        <div class="privacy-policies-page-container">
            <h2 class="text-center py-5">Billing Terms & Conditions</h2>

            <div class="Privacy-policies headline-section">Warranty Period</div>
            <div class="privacy-policies-para">
                The product covers a 12 months warranty for material & manufacturing faults. Five years warranty only for
                the wood-louse (Ghun) attack. The warranty will be applied, after an analysis of the actual situation. By
                ensure a skilled customer care representative to the customer premises.
            </div>

            <div class="Privacy-policies headline-section">Warranty Procedure</div>
            <div class="privacy-policies-para">
                Customers are requested to keep the purchase voucher to avail the service. There is no warranty or guarantee
                for the glass, fabric or rexin. The company has the right to rework, repair and replace only the defective
                part or
                parts of the product in case of a warranty.
            </div>

            <div class="Privacy-policies headline-section">Terms of Payment</div>
            <div class="privacy-policies-para">
                50% advance payment is mandatory out of total order value. The remaining payment must be made at least 48
                hours before delivery of the product.
            </div>

            <div class="Privacy-policies headline-section">Mode of Payment</div>
            <div class="privacy-policies-para">
                Acceptable payment mode is cash, Fund Transfer (Bank Account, Mobile Banking), credit card and cheque.
                If payment were made by cheque the delivery would be made after the encasement of the cheque.
            </div>

            <div class="Privacy-policies headline-section">Fitting Schedule</div>
            <div class="privacy-policies-para">
                For Knockdown Furniture, Technician will be available at customer point within 48 hours after delivery of
                the product.
            </div>

            <div class="Privacy-policies headline-section">Order Change or Cancellation</div>
            <div class="privacy-policies-para">
                Order cancellation is not acceptable but it can be changed within three days. It is not applicable for
                customized, set
                broken & fabrics products.
            </div>

            <div class="Privacy-policies headline-section">Order Validity</div>
            <div class="privacy-policies-para">
                6 months from the date of order.
            </div>

            <div class="Privacy-policies headline-section">Delivery Period</div>
            <div class="privacy-policies-para">
                Delivery will be made from ready-stock. If there is no stock, the date will be fixed upon discussion with
                the customer. The delivery date may change for any unavoidable circumstances.
            </div>

            <div class="Privacy-policies headline-section">Product Development</div>
            <div class="privacy-policies-para">
                Product development is a continuous process and thus there could be minor changes in different versions of
                the product. This will not affect the functional value of the product.
            </div>
        </div>
        <div class="privacy-policies-page-container">
            <h3 class="text-center pb-5">User instructions</h3>

            <ul class="user-instruction-list">
                <li>Any spillage should be wiped quickly with a soft dry cloth to avoid discoloration.</li>
                <li>To adjust the position of furniture, it should be lifted rather than dragged across a completed surface.
                </li>
                <li>Avoid placing your furniture in direct sunlight, wet & humid place. Maintaining relative humidity and
                    temperature
                    is critical for extending the life of good wood furniture, leather, and upholstery.</li>
                <li>Solid tabletops, for example, will expand somewhat in the summer and compress in the winter months with
                    no
                    deleterious consequences.</li>
                <li>Do not use nail polish remover, hair spray, perfume and glass cleaner (along with any other
                    solvent-containing items)
                    on a hardwood surface.</li>
                <li>Use a protective layer (cotton, linen, or felt fabric) between any object and the lacquer finish surface
                    to prevent damage.</li>
                <li>Avoid exposing the furniture finish to devices that produce high heat, cold, or moisture (e.g., laptop,
                    desktop, oven, etc.).</li>
                <li>Remember that our furniture is termite resistant but not white-ant resistant. Ample sunlight and airflow
                    can keep white ants away from your furniture. Furthermore, fungus grows on your furniture in a wet and
                    damp environment.</li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { useStaticSchema } from '@/libs/utils/seo-helper'
useHead({
  title: 'Terms & Conditions - Akhter Furnishers',
  meta: [
    { name: 'description', content: 'Review the terms and conditions for using our website and purchasing products.' }
  ]
})

useStaticSchema('terms-conditions')
</script>

<style lang="scss" scoped>
.privacy-policies-page-container {
    padding: 25px 10%;
}

.drop-down-language-container {
    border: 2px solid #e6e6e6;
    border-radius: 10px;
    font-size: 18px;
    padding: 17px 21px;
    width: 20%;
    margin-bottom: 50px;
}

.headline-section {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 20px;
}

.text-section {
    font-size: medium;
    font-weight: 400;
}

.heading-and-image-section {
    align-items: center;
}

.heading-section {
    font-size: 50px;
}

.outlet-banner {
    background-color: #f5f5f5;
    padding: 0 10%;
    height: 30vh;
    text-align: center;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
.user-instruction-list {
    margin-left: -25px;
}

@media screen and (min-width: 0px) and (max-width: 576px) {
    .heading-section {
        font-size: 35px;
    }
}
</style>
